// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"e639ab2c","808":"e5487989","857":"87eaa34a","884":"9233c019","922":"093592d5"}[chunkId] + ".chunk.js";
};